import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { TransporteurDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-transporteur-select',
  templateUrl: './transporteur-select.component.html',
  styleUrls: ['./transporteur-select.component.css']
})
export class TransporteurSelectComponent implements OnInit {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.transporteurs$) transporteurs$: Observable<TransporteurDto[]>;

  @Input('width') width: number;
  @Input('disabled') disabled: boolean = false;

  @Input() transporteurId: number;
  @Output() transporteurIdChange = new EventEmitter<number>();

  @Input() titleNull: string;

  Transporteurs: TransporteurDto[] = [];
  ColumnName = [];

  t: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Identifiant'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations['Identifiant']);
    });
  }

  ngOnInit() {
    this.t = this.transporteurs$.subscribe(res => {
      if (res != null) {
        this.Transporteurs = res.sort((a,b) => (a.Identifiant > b.Identifiant) ? 1 : ((b.Identifiant > a.Identifiant) ? -1 : 0));;
        if (this.titleNull && !this.Transporteurs.find(p => p.Id == 0))
        {
          this.Transporteurs.unshift({ Id: 0, Identifiant: this.titleNull });
        }
      }
    });
  }

  ngOnDestroy() {
    this.t?.unsubscribe();
  }

  updateInfo(event) {
    this.transporteurId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.transporteurId;
    this.transporteurIdChange.emit(this.transporteurId);

    if(this.transporteurId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.transporteurId == null) {
      this.dataGrid.instance.clearSelection();
    }
  }
}
